import { useContext, useEffect, useState } from 'react'
import MenuBarComponent from './MenuBarComponent'
import { useTranslation } from 'react-i18next';
import { MegaMenu } from 'primereact/megamenu';
import { useNavigate } from 'react-router-dom';
import AuthContext from '../Contexts/AuthContext';
import OraculoComponent from './OraculoNuma/OraculoComponent';
import InitialTourComponent from './InitialTourComponent';

function AppBodyComponent({children}) {
    const { t } = useTranslation('user_home');
    const navigate = useNavigate()
    const {userAuth, activeMenu} = useContext(AuthContext)
    const itemTemplate = (item) => {
        return (
            <div className={`flex flex-column lg:flex-row justify-content-start align-items-center p-2 gap-2 ${item.tourClass || ''} ${activeMenu === item.activeMenu ? 'font-bold' : '' }`}>
                <i className={`${item.icon} `} />
                <span className={`text-sm md:text-base white-space-nowrap`}>{item.label}</span>
            </div>
        )
    }

    const basicItems = [
        {
            label: t('user_home_event_page_title'),
            command: ()=>navigate('/app/user_home_events'),
            icon: 'pi pi-calendar',
            template: itemTemplate,
            activeMenu: 1,
            tourClass: 'tour-menu-calendar'
        },
        {
            label: t('user_home_place_page_title'),
            command: ()=>navigate('/app/user_home_places'),
            icon: 'pi pi-users',
            template: itemTemplate,
            activeMenu: 2,
            tourClass: 'tour-menu-community'
        },
    ]

    const [items, setItems] = useState(basicItems)

    useEffect(()=>{
        let _items = [...basicItems]
        userAuth?.user?.religious_place_access_key && _items.length === 2 && _items.push({
                label: t('user_home_my_place_page_title'),
                command: ()=>navigate('/app/user_home_my_place'),
                icon: 'pi pi-home',
                template: itemTemplate,
                activeMenu: 3,
                tourClass: 'tour-menu-my-community'
            }
        )
        setItems(_items)
    },[activeMenu])

    const initalTourSteps = [
        {
            title: t('initial_tour.calendar_title'),
            content: t('initial_tour.calendar_text'),
            target: '.tour-menu-calendar',
            placement: 'bottom'
        },
        {
            title: t('initial_tour.community_title'),
            content: t('initial_tour.community_text'),
            target: '.tour-menu-community',
            placement: 'bottom'
        },
        {
            title: t('initial_tour.my_community_title'),
            content: t('initial_tour.my_community_text'),
            target: '.tour-menu-my-community',
            placement: 'bottom'
        },
        {
            title: t('initial_tour.spaces_title'),
            content: t('initial_tour.spaces_text'),
            target: '.tour-main-content',
            placement: 'top'
        },
        {
            title: t('initial_tour.numa_title'),
            content: t('initial_tour.numa_text'),
            target: '.tour-numa-anchor',
            placement: 'top'
        },
    ]


    return (
        <div className='flex flex-column gap-2'>
            <MenuBarComponent />
            <div className='flex flex-column lg:flex-row gap-2'>
                <MegaMenu model={items} orientation='horizontal' className='flex w-full lg:w-3 xl:w-15rem justify-content-center lg:align-items-start joyride-menu' />

                <div className='p-2 md:p-4 w-full tour-main-content'>
                    {children}
                </div>
            </div>
            <OraculoComponent />
            <InitialTourComponent steps={initalTourSteps} userId={userAuth?.user?.id} />
        </div>
    )
}

export default AppBodyComponent